<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <!-- <div class="small-box bg-warning card d-flex flex-row justify-content-between">
                    <div class="text-center">
                        <h4 class="p-2">Inspire and inform yourself with these Movement Videos</h4>
                        <h6 class="p-2">(Get featured here. Simply post a link in our forum.)</h6>
                        <small class="p-2" >Learn the general movement, and use them in your own Workouts. If others can do them, you can too. <br/>We all start small</small>
                    </div>
                </div> -->
                <div class="card card-widget widget-user">
                <div class="widget-user-header text-white"
                                style="background: url('/assets/images/child_at_bottom_of_steps_beginning_1250x835x2.png')  center;">
                                <h2 class="widget-user-username text-left">Inspire and Inform yourself</h2>
                                <h2 class="widget-user-username text-right text-dark">Begin. Grow. Evolve.</h2>
                                <h5 class="widget-user-desc text-right">We all start small.</h5>
                                <h6 class="widget-user-desc text-left text-dark">(You can be featured on this page. Simply post a link in our forum.)</h6>
                              <!-- <small class="widget-user-username text-left" >Learn the general movement, and use them in your own Workouts. If others can do them, you can too. <br/>We all start small</small> -->
                            </div>
                            <div class="widget-user-image">
                                <img class="img-circle" src="/assets/images/beginner_child.png" alt="User Avatar">
                            </div>
                </div>
                <div class="card p-2 m-6 bg-default">
                            <div class="row mt-2 ml-2"><h5>Search the video library:</h5></div>
                            <div class="row">
                                <div class="col-md-4">
                                    <input class="form-control" v-model="name_filter" placeholder="Search by name" @change="filterByMovementName($event.target.value)"/>
                                </div>
                                <div class="col-md-3">
                                    <select class="form-control" v-model="bodypart_filter" @change="filterByBodyPart($event.target.value)">
                                        <option value="">Select BodyPart</option>
                                        <option
                                            v-for="part in bodypartData"
                                            :key="part"
                                            :value="part"
                                        >{{ part }}</option>
                                    </select>
                                </div>
                                <div class="col-md-4 content-center">
                                    <select  class="form-control" v-model="movementtype_filter" @change="filterByMovementType($event.target.value)">
                                    <option value="">Select (Body-Wt or (Gym)Weights)</option>
                                        <option  value="TRUE">BodyWeight Only</option>
                                        <option value="FALSE">(Gym)Weights Only</option>
                                    </select>
                                </div>
                                <div class="col-md-1 content-right">
                                   <button class="btn btn-primary btn-sm"  :disabled="filteredMovements.length <1"  @click="resetFilter()" >
                                    <i class="fa fa-refresh text-white"  aria-hidden="true">Reset</i>
                                   </button>
                                </div>
                            </div>
                        <!-- <div class="d-flex justify-content-between"> -->
                            <div class="row mt-2 d-flex justify-content-center">
                                <div class="col-md-2 content-right">Video List:&nbsp;</div>
                                <div class="col-md-3 content-left">
                                    <select  style="width:20em;" class="form-control" :disabled="filteredMovements.length <1" v-model="displayVideo" @change="showVideoModal($event.target.value)">
                                        <option value="">Select One</option>
                                        <option
                                            v-for="movement in filteredMovements"
                                            :key="movement.id"
                                            :value="movement.id"
                                        >{{ movement.movementname }}</option>
                                    </select>
                                </div>
                            </div>
                        <!-- </div> -->

                </div>


                <h4 class="mt-4 mb-4">Featured Videos</h4>
                <div class="list-group-item">
                    <div class="row">
                        <div v-for="movement in featuredVideos" :key="movement.id" class="col-auto col-md-4">
                            <div class="content-box-gray card" >
                            <div class="title text-center">
                                <h6 class="mt-2" style="margin:auto;" v-html="movement.bodypart +': '+movement.movementname"></h6></div>
                                <div class="content">
                                    <iframe width="360" :src="getURL(movement.videourl)" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" class="border-0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <videodisplaymodal></videodisplaymodal>
            </div>
        </div>
 <div class="row mt-2">
<div class="col-md-6">

                </div>
</div>
</div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';


export default {
    components:{

     },
    name: "VideoLibrary",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            allmovements:[],
            userinfo:'',
            name_filter:'',
            bodypart_filter:'',
            movementtype_filter:'',
            bodypartData:[],
            movementData:[],
            selected_movement: '',
            filteredMovements: [],
            featuredVideos: [],
            displayVideo:'',
            overall_videos:'',



      }
    },

    props: {
        userdata:'',
        movements:[],
        bodyparts:'',
    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.movementData = JSON.parse(this.movements);
        this.bodypartData = JSON.parse(this.bodyparts);
        this.getFeaturedVideos();
    },

    methods: {
        resetFilter() {
            this.filteredMovements = '';
            this.name_filter = '';
            this.bodypart_filter = '';
            this.movementtype_filter = '';
        },
        getURL(videourl) {
            if(videourl.includes('outube')) return videourl + '+?controls=0';
            return videourl;//vimeo
        },
        getBoxTitle(workout) {
            return this.getWeekName(workout) + ": " +this.getNumOfWeekWorkout(workout);
        },
        showVideoModal(wrkoutid) {
            console.error(wrkoutid);
            var workout = '';
             [...this.filteredMovements].forEach((aMov)=>{
                    if(aMov.id == wrkoutid){
                        workout = aMov;
                        console.log(workout);
                    }
            });
            if(workout) {
            const payload = {
                workout: workout,
                };
              EventBus.$emit('displayVideoModal', payload);
            }
        },
        filterByBodyPart(bodypart) {
            var bodypartLC = bodypart.toUpperCase().trim();
            // console.log(bodypartLC);
            this.filteredMovements = [...this.movementData].filter((movement, bodypartLC) => {
                    // console.error("BodyPart: " + bodypart);
                    //  console.log("Checking: " + movement.movementname + " " + movement.bodypart.toUpperCase() + " " + bodypart);
                    // if(movement.bodypart.toUpperCase().trim() == bodypartLC) {
                 if(movement.bodypart.toUpperCase().includes(bodypart.toUpperCase())) {
                        console.log("Found: " + movement.movementname);
                        return movement;
                    }
            });
        },
         getFeaturedVideos() {
            this.featuredVideos = [...this.movementData].filter((movement) => {
                    // console.error("BodyPart: " + bodypart);
                    //  console.log("Checking: " + movement.movementname + " " + movement.bodypart.toUpperCase() + " " + bodypart);
                    // if(movement.bodypart.toUpperCase().trim() == bodypartLC) {
                 if(movement.featured) {
                        console.log("Featured: " + movement.videourl);
                        return movement;
                    }
            });
        },
        filterByMovementType(isBodyWt) {
            console.error(isBodyWt);
            this.filteredMovements = [...this.movementData].filter((movement) => {
                    if(movement.bodyweight === isBodyWt) {
                        console.log(movement.bodyweight);
                            return movement;
                    }
            });
        },

        filterByMovementName(keyword) {
            var word =  keyword.toLowerCase();
            this.filteredMovements = [...this.movementData].filter((movement) => {
                    return movement.movementname.toLowerCase().includes(word);
            });
        }


    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}

</style>
